import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BE_URL } from "config/api";
import { RootState } from "app/store";

export const baseApi = createApi({
  reducerPath: "api",
  tagTypes: [
    "Order",
    "Checklist",
    "ChecklistComment",
    "Thumbnail",
    "Media",
    "Signature",
    "OrderSerial",
    "SerialEntity",
    "User",
    "Installer",
    "Absentee",
    "UserStatistics",
    "Booking",
    "Company",
    "Customer",
    "Department",
    "Office",
    "TimeEntry",
    "OrderIncompleteReason",
    "CompanyComment",
    "CompanyContact",
    "CompanyOffice",
    "CompanyUser",
    "CompanyOrderStats",
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: BE_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set("token", (getState() as RootState).auth.token || "");
      return headers;
    },
  }),
  endpoints: () => ({}),
});

export default baseApi;
